import { UntypedFormControl } from '@angular/forms';

export function validateAgeOrDobInput(c: UntypedFormControl) {
  return c.value ? null : {
    validateAgeOrDobInput : {
      valid: false
    }
  };
}
